import { __assign } from "tslib";
import { defaultAudioProps, STATE_EVENTS, } from '@wix/soundhead-playback';
import { noop, promiseNoop } from './utils';
export var defaultTrackState = {
    muted: false,
    volume: 1,
    playbackRate: 1,
    loop: false,
    autoplay: false,
    preload: 'auto',
    duration: 0,
    currentTime: 0,
    buffered: 0,
    playbackState: STATE_EVENTS.INIT,
    durationFormatted: '00:00',
    currentTimeFormatted: '00:00',
    remainingFormatted: '00:00',
    isPlaying: false,
    isLoading: false,
    isSeeking: false,
    isPlayingInterrupted: false,
    isLiveStream: false,
    trackIndex: 0,
};
export var defaultPlayerProps = {
    playlist: [],
    loop: false,
    autoplay: false,
    muted: false,
    volume: 1,
    playbackRate: 1,
    duration: 0,
    onTrackReadyToPlay: noop,
    onPlayRequested: noop,
    onPlay: noop,
    onPause: noop,
    onTimeUpdated: noop,
    onDurationChanged: noop,
    onVolumeChanged: noop,
    onMuteChanged: noop,
    onRateChanged: noop,
    onEnded: noop,
    onAborted: noop,
    onError: noop,
    onFocus: noop,
};
var mockEventEmitter = {};
export var defaultPlayback = {
    destroy: noop,
    reset: noop,
    registerPlayer: noop,
    hasRegisteredPlayer: function () { return false; },
    getPlayerId: function () { return ''; },
    getPlaylist: function () { return []; },
    setPlaylist: noop,
    getTrackIndex: function () { return 0; },
    setTrackIndex: noop,
    getAudioProps: function () { return defaultAudioProps; },
    setAudioProps: noop,
    setMute: promiseNoop,
    setVolume: promiseNoop,
    setPlaybackRate: promiseNoop,
    setLoop: noop,
    setAutoplay: noop,
    play: promiseNoop,
    pause: promiseNoop,
    seekTo: promiseNoop,
    next: promiseNoop,
    previous: promiseNoop,
    on: function () { return mockEventEmitter; },
    once: function () { return mockEventEmitter; },
    off: function () { return mockEventEmitter; },
};
export var defaultPlaybackContext = __assign({ play: promiseNoop, pause: promiseNoop, next: promiseNoop, previous: promiseNoop, togglePlay: promiseNoop, seekTo: promiseNoop, setPlaybackRate: promiseNoop, toggleMute: promiseNoop, setVolume: promiseNoop, handleKeyDown: promiseNoop, setTrackIndex: noop, getTrackIndex: function () { return 0; }, setFormattedTime: noop, playlist: [], url: '' }, defaultTrackState);
//# sourceMappingURL=defaultSettings.js.map